import { c as _c } from "react/compiler-runtime";
import * as React from "react";
const MOBILE_BREAKPOINT = 768;
const getServerSnapshotFalse = () => false;

/**
 * True when viewport width is strictly less than `maxWidthExclusive`.
 * False on the server and hydration render; the first client render reads
 * the live viewport width and re-renders on media-query changes.
 */
export function useIsMaxWidth(maxWidthExclusive) {
  const $ = _c(4);
  let t0;
  if ($[0] !== maxWidthExclusive) {
    t0 = onChange => {
      const mql = window.matchMedia(`(max-width: ${maxWidthExclusive - 1}px)`);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    };
    $[0] = maxWidthExclusive;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const subscribe = t0;
  let t1;
  if ($[2] !== maxWidthExclusive) {
    t1 = () => window.innerWidth < maxWidthExclusive;
    $[2] = maxWidthExclusive;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getSnapshot = t1;
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshotFalse);
}
export function useIsMobile() {
  return useIsMaxWidth(MOBILE_BREAKPOINT);
}
const HOVER_POINTER_QUERY = "(hover: hover) and (pointer: fine)";
function subscribeToHoverPointer(onChange: () => void) {
  const mql = window.matchMedia(HOVER_POINTER_QUERY);
  mql.addEventListener("change", onChange);
  return () => mql.removeEventListener("change", onChange);
}

/**
 * True when the primary pointer can hover and is precise (mouse/trackpad).
 * False on touch-first devices regardless of viewport width, so hover-driven
 * affordances can stay available in narrow desktop windows.
 *
 * Read synchronously on mount (server snapshot false) so gated chrome renders
 * on the first client paint: the session switcher hint must not blink out for
 * a frame when the sidebar skeleton swaps to the live sidebar.
 */
export function useHasHoverPointer() {
  return React.useSyncExternalStore(subscribeToHoverPointer, _temp, _temp2);
}
function _temp2() {
  return false;
}
function _temp() {
  return window.matchMedia(HOVER_POINTER_QUERY).matches;
}